import { alpha, styled } from '@mui/material/styles';
import { Card, Typography, Link } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import axios from 'axios';
import { fShortenNumber } from '../../../utils/formatNumber';
import { isEmpty } from 'lodash';

export const RootStyle = styled(Card, {
    shouldForwardProp: (prop) => prop !== 'colorKey',
})(({ theme, colorKey }) => ({
    boxShadow: 'none',
    textAlign: 'center',
    padding: theme.spacing(5, 0),
    color: theme.palette[colorKey].darker,
    backgroundColor: theme.palette[colorKey].lighter
}));

const IconWrapperStyle = styled('div', {
    shouldForwardProp: (prop) => prop !== 'colorKey',
})(({ theme, colorKey }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    color: theme.palette[colorKey].dark,
    backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette[colorKey].dark, 0)} 0%, ${alpha(
        theme.palette[colorKey].dark,
        0.24
    )} 100%)`
}));

export default function GenericDashboardCard({
    title,
    iconClassName,
    colorKey = 'error',
    fetchUrl,
    filterFunction = (data) => data,
    redirectPath = '',
}) {
    const [total, setTotal] = useState(0);

    useEffect(() => {
        async function getData() {
            try {
                const res = await axios.get(fetchUrl);
                let data = res.data?.data || [];
                data = filterFunction(data);
                setTotal(data.length);
            } catch (error) {
                console.error('Fetch error:', error);
            }
        }
        getData();
    }, [fetchUrl, filterFunction]);

    const CardContent = (
        <>
            {iconClassName && (
                <IconWrapperStyle colorKey={colorKey}>
                    <i className={iconClassName} style={{ fontSize: '30px' }} />
                </IconWrapperStyle>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', height: '90px' }}>
                <Typography variant="h3">{fShortenNumber(total)}</Typography>
                <Typography variant="subtitle1" sx={{ pt: '15px', pl: '10px' }} >
                    {title}
                </Typography>
            </div>
        </>
    );

    return (
        <RootStyle colorKey={colorKey}
            sx={{
                boxShadow:
                    'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
                borderRadius: 2, // optional if you want rounded corners
            }}
        >
            {!isEmpty(redirectPath) ? (
                <Link
                    style={{ display: 'block' }}
                    variant="subtitle1"
                    component={RouterLink}
                    to={redirectPath}
                    underline="none"
                >
                    {CardContent}
                </Link>
            ) : (
                CardContent
            )}
        </RootStyle>
    );
}
